export interface ReservationTgListItem {
  propostaId: number
  contratoId?: string
  codigoTg: string
  nomeEvento: string
  clienteId?: number
  nomeCliente: string
  subClienteId?: number | null
  nomeSubCliente?: string | null
  dataInicio: string
  dataFinal: string
  totalOs: number
  osPendentes: number
  osComFornecedor?: number | null
  totalValorVendaComTaxa?: number | null
  totalValorVendaSemTaxa?: number | null
  totalValorCompra?: number | null
  totalValorComprado?: number | null
  totalSavings?: number | null
  consultorOperacionalId?: number | null
  nomeConsultorOperacional?: string | null
  fornecedorAtribuidoPor?: number | null
  nomeFornecedorAtribuidoPor?: string | null
}

export class SearchReservationTgModel {
  public codigoTg: string | null = null
  public nomeCliente: string | null = null
  public clienteId: number | null = null
  public dataInicio: string | null = null
  public dataFinal: string | null = null
  public consultorOperacionalId: number | null = null
  public fornecedorAtribuidoPor: number | null = null
}

export interface PurchaseScheduleServiceOrderListItem {
  cosId: string
  codigoOs: string
  dataInicio: string
  horaInicio: string
  dataFinal: string
  horaFinal: string
  observacaoOs?: string | null
  statusOsId: number
  descricaoStatusOs: string
  statusOsAndamentoId: number
  statusOsAndamento: string
  codigoTg: string
  contratoId?: string
  nomeEvento: string
  quantidadePassageiros: number
  pax?: number | null
  enderecoCompleto?: string | null
  nomeCliente: string
  nomeSubCliente?: string | null
  descricaoOrigem: string
  descricaoDestino: string
  servico: string
  descricaoTipoServico: string
  tipoVeiculoId?: number | null
  descricaoTipoVeiculo?: string | null
  tipoMotoristaId?: number | null
  descricaoTipoMotorista?: string | null
  fornecedorId?: number | null
  nomeFornecedor?: string | null
  statusComprasId: number
  descricaoStatusCompras: string
  valorTotal?: number | null
  valorCompra?: number | null
  freelancer?: boolean | null
  valorMotorista?: number | null
  valorVendaComTaxa?: number | null
  valorVendaSemTaxa?: number | null
  quantidadeVeiculo?: number | null
  quantidadeMotorista?: number | null
  isPendente: 'S' | 'N'
  consultorOperacionalId?: number | null
  nomeConsultorOperacional?: string | null
  fornecedorAtribuidoPor?: number | null
  nomeFornecedorAtribuidoPor?: string | null
}

export interface CreatePurchaseServiceOrderModel {
  ordemServicoId: string
  tipoVeiculoId?: number | null
  tipoMotoristaId?: number | null
  quantidadeVeiculo?: number
  quantidadeMotorista?: number
}

export interface EditPurchaseServiceOrderModel {
  id: string
  fornecedorId: number
  valorCompra: number
  freelancer: boolean
  valorMotorista: number
  enviarEmail: boolean
  multiplicadorVenda?: number
  observacaoOs?: string | null
  obsFornecedorOperador?: string | null
}

export interface EditPurchaseServiceOrderBatchModel {
  comprasOsIds: string[]
  fornecedorId: number
  valorCompra: number
  freelancer: boolean
  valorMotorista: number
  enviarEmail: boolean
  multiplicadorVenda?: number
  observacaoOs?: string | null
  obsFornecedorOperador?: string | null
}

export interface EditPaymentTermModel {
  prazoPagamento: number | null
}

export interface EditPurchaseServiceOrderBatchResponse {
  sucesso: string[]
  erros: { comprasOsId: string; mensagem: string }[]
}

export interface NotifyPurchaseServiceOrderModel {
  comprasOsIds: string[]
  enviarEmail: boolean
  gerarLinkWhatsApp: boolean
}

export interface NotifyPurchaseServiceOrderResponse {
  emailsEnviados: number
  linksWhatsApp: { nomeFornecedor: string; codigosOs: string[]; link: string }[]
}

export interface WhatsAppAccessLinkResponse {
  codigoOs: string
  nomeFornecedor: string
  senhaAcesso: string
  linkAcesso: string
  mensagem: string
  linkWhatsApp: string
}

export interface PurchaseServiceOrderGeneralVm {
  id: string
  tipoComprasId?: number
  descricaoTipoCompras?: string
  statusCompra?: number
  descricaoStatusCompra?: string
  contratoId?: string
  codigoTg: string
  codigoOs: string
  dataInicio: string
  datafinal: string
  horaInicio: string
  horafinal: string
  fornecedorId?: number | null
  nomeFornecedor?: string | null
  tipoveiculoId?: number | null
  descricaoTipoVeiculo?: string | null
  tipoMotoristaId?: number | null
  descricaoTipoMotorista?: string | null
  quantidadeVeiculo?: number | null
  quantidadeMotorista?: number | null
  valorTotal?: number | null
  observacaoOs?: string | null
  valorCompra?: number | null
  freelancer?: boolean | null
  valorMotorista?: number | null
  multiplicadorVenda?: number | null
  target?: number | null
  savings?: number | null
  valorVendaComTaxa?: number | null
  valorVendaSemTaxa?: number | null
  divisor?: number | null
  obsCliente?: string | null
  obsFornecedorOperador?: string | null
  valorTarifario?: number | null
  prazoPagamento?: number | null
  consultorOperacionalId?: number | null
  nomeConsultorOperacional?: string | null
  emailConsultorOperacional?: string | null
  fornecedorAtribuidoPor?: number | null
  nomeFornecedorAtribuidoPor?: string | null
}

export class SearchPurchaseScheduleServiceOrderModel {
  public codigoTg: string | null = null
  public codigoOs: string | null = null
  public nomeCliente: string | null = null
  public clienteId: number | null = null
  public dataInicio: string | null = null
  public dataFinal: string | null = null
  public descricaoOrigem: string | null = null
  public descricaoDestino: string | null = null
  public servico: string | null = null
  public tipoVeiculoId: number | null = null
  public tipoMotoristaId: number | null = null
  public pendente: boolean | null = null
  public statusComprasId: number | null = null
  public statusOsId: number | null = null
  public consultorOperacionalId: number | null = null
  public fornecedorAtribuidoPor: number | null = null
}
